module.exports = "/_next/static/images/ff2bc35fbb382b37c7d0533be3047760-man-looking-up-smiling-lg@2x.jpg";